import { useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  type ISetIsClickToTextActionShown,
  ClickToTextListStore,
} from 'pages/clickToText/pages/all/store'
import { ClickToTextListContext } from 'pages/clickToText/pages/all/context'
import { ClickToTextListContent } from './ClickToTextListContent'

type IClickToTextListProps = {
  setIsClickToTextActionShown: ISetIsClickToTextActionShown
}

export const ClickToTextList = ({ setIsClickToTextActionShown }: IClickToTextListProps) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new ClickToTextListStore(setIsClickToTextActionShown, entities))

  useEffect(() => {
    return store.dispose
  }, [])

  return (
    <ClickToTextListContext.Provider value={store}>
      <ClickToTextListContent />
    </ClickToTextListContext.Provider>
  )
}
